import React from 'react'
import MenuNavbar from '../function-components/MenuNavbar';
import Floaticons from '../function-components/Floaticons';
import './Cyberedge.css'
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs } from "@material-ui/core";
import Typography from '@mui/material/Typography';

function Cyberedge() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <div className="breadcrumbs-container">
                    <Breadcrumbs separator=">" color="#fff">
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="#fff"
                            href="/"
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        </Link>,
                        <Link
                            underline="hover"
                            key="2"
                            color="#fff"
                            href="/KeyInitiatives"
                        // onClick={handleClick}
                        >
                            Key Initiatives
                        </Link>,
                        <Typography key="3" color="#fff">
                            CyberEdge
                        </Typography>,
                    </Breadcrumbs>
                </div>
                <MenuNavbar />
            </div>
            {/* <Floaticons /> */}

            <section className="vision-section">
                <h1 className='vision-title'>CyberEdge</h1>
                <h2 className="vision-title">Vision</h2>

                <div className="vision-wrapper">
                    {/* Vision light background */}

                    <img
                        className="vision-light-img"
                        src={`${process.env.PUBLIC_URL}/images/Cyberedge/vision-light.png`}
                        alt=""
                        aria-hidden="true"
                    />


                    <div className="vision-inner">
                        <div className="vision-left">
                            <img
                                src="images/Cyberedge/Telescope-img.svg"
                                alt="Vision Telescope"
                                className="vision-telescope"
                            />
                        </div>

                        <div className="vision-right">
                            <div className="vision-cards">
                                <div className="vision-card">
                                    <div className="vision-icon purple">
                                        <img src="images/Cyberedge/power_icon.svg" alt="icon" />
                                    </div>
                                    <div className="vision-content">
                                        <p>
                                            <strong>To engage and empower</strong> employees at
                                            <strong> CL9 to CL6</strong> across all markets by providing opportunities
                                            to learn application security concepts and develop secure software,
                                            enabling us to join forces in our mission to
                                            <strong> SECURE THE WORLD.</strong>
                                        </p>
                                    </div>
                                </div>

                                <div className="vision-card vision-card2">
                                    <div className="vision-icon light-purple">
                                        <img src="images/Cyberedge/lock_icon.svg" alt="icon" />
                                    </div>
                                    <div className="vision-content">
                                        <p>
                                            By equipping our workforce with
                                            <strong> cybersecurity skills</strong>, we will
                                            <strong> close the talent gap</strong> and build a resilient future where
                                            <strong> security is at the core of every innovation.</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="Overall_struct_container">
                <h2 className='overall_head'>
                    CyberEdge Overall Structure
                </h2>
                <h3 className='overall_sub'>
                    Objective
                </h3>
                <p>
                    To engage and empower employees at CL9 to CL6 across all markets by providing opportunities to learn application security concepts and develop secure software, enabling us to join forces in our mission to SECURE THE WORLD. By equipping our workforce with cybersecurity skills, we will close the talent gap and build a resilient future where security is at the core of every innovation.
                </p>
                <div className="arrow_cont">
                    <img src="images/Cyberedge/target_arrow.svg" alt="Target_icon" className='target_img' />
                    <p>
                        This program includes regular SME sessions that equip participants with practical cybersecurity skills, driving measurable growth and certification readiness
                    </p>
                    <img src="images/Cyberedge/target_arrow.svg" alt="Target_icon" className='target_img' />
                </div>
                <img src="images/Cyberedge/Overall_img1.svg" alt="" className='tar_img' />
            </div>

            <div className="LearningPlan">
                <h2 className='learning_head'>CyberEdge Learning Plan</h2>
                <img src="images/Cyberedge/Learning_plan_img.svg" alt="Learning_Plan" className='tar_img' />

            </div>

            <div className="Imp_dates">
                <h2 className='dates_head'>Important Dates</h2>
                <img src="images/Cyberedge/Important_dates-img.svg" alt="SME_Sessions" className='imp_dates_img'/>
            </div>


        </>

    );
}

export default Cyberedge;